import cn from 'classnames';

import OPE from 'js/on-page-editing';
import { FrontpageHeader_EditorThemeMap, getEnumStringValue } from 'js/utils/enum-string-maps';

import Image from 'components/image/Image';
import Link from 'components/link/Link';

import { IFrontpageHeader } from 'source/NFR.types';

const FrontpageHeader: React.FC<IFrontpageHeader> = ({
  image,
  title,
  description,
  links = [],
  onPageEditing,
  editorTheme
}) => {
  return (
    <div className={cn('frontpage-header', getEnumStringValue(FrontpageHeader_EditorThemeMap, editorTheme))}>
      <div className="frontpage-header--prioritised-content">
        {title && <h1 className="frontpage-header--title">{title}</h1>}
        {description && <p className="frontpage-header--description">{description}</p>}
        <div className="frontpage-header--links" {...OPE(onPageEditing?.links)}>
          {links?.map((link, index) => (
            <Link
              className="frontpage-header--link"
              key={`${link.url}-${index}`}
              useButtonStyles
              theme={['large', index === 0 ? 'signal' : 'secondary']}
              {...link}
            />
          ))}
        </div>
      </div>
      <div className="frontpage-header--image">
        {image && (
          <Image
            {...image}
            width={1920}
            height={500}
            sources={[
              {
                media: '(min-width: 1600px)',
                width: 1920
              },
              {
                media: '(min-width: 1280px)',
                width: 1280
              },
              {
                media: '(min-width: 1024px)',
                width: 720,
                height: 500
              },
              {
                media: '(min-width: 768px)',
                width: 384,
                height: 500
              },
              {
                media: '(min-width: 510px)',
                width: 510,
                height: 250
              },
              {
                media: '(max-width: 509px)',
                width: 330,
                height: 250
              }
            ]}
            sizes="(min-width: 1600px) 1200px, (min-width: 1280px) 640px, (min-width: 1024px) 512px, (min-width: 768px) 384px, (min-width: 510px) 510px, 330px"
            loading="eager"
            fetchPriority="high"
            theme="anchored"
            isFluid={true}
          />
        )}
      </div>
    </div>
  );
};

FrontpageHeader.displayName = 'FrontpageHeader';

export default FrontpageHeader;
